<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="loglist"
    size="md"
    body-class="bg-white"
    ok-only
    ok-title="Ok"
    title="Log List"
    ref="loglist"
  >
    <p v-for="item in message" :key="item.id">* {{ item }}</p>
  </b-modal>
</template>

<script>
export default {
  props: ["message"]
};
</script>

<style>
</style>
